import {token} from '../constants/environment';

export const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'api-key': token,
};
